// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__pk7QQ","col":"styles_col__13ZKs"};